import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';

/**
 * A helper hook to trace updates to a hook/component
 * Just pass an object with keys containing properties that you want to trace
 */
function useTraceUpdate(props, traceKey) {
  const $ = _c(3);
  const prev = useRef(props);
  let t0;
  if ($[0] !== props || $[1] !== traceKey) {
    t0 = () => {
      const changedProps = Object.entries(props).reduce((ps, t1) => {
        const [k, v] = t1;
        if (prev.current[k] !== v) {
          ps[k] = [prev.current[k], v];
        }
        return ps;
      }, {} as Record<string | number | symbol, [unknown, unknown]>);
      if (Object.keys(changedProps).length > 0) {
        console.log(`Changed props for ${traceKey}:`, changedProps);
      }
      prev.current = props;
    };
    $[0] = props;
    $[1] = traceKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useEffect(t0);
}
export default useTraceUpdate;